"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.defaultState = exports.default = exports.IndicatorProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dateFns = require("date-fns");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const defaultState = {
  cookies: _jsCookie.default.get(),
  isOnPrettyUrl: () => true,
  checkForFeedback: () => {},
  trackEvent: () => {},
  setCookie: () => {},
  getCookie: () => ``,
  removeCookie: () => {},
  setCurrentBuildStatus: () => {},
  setBuildInfo: () => {},
  setContentSyncInfo: () => {},
  setManifestInfo: () => {}
};
exports.defaultState = defaultState;
const IndicatorContext = /*#__PURE__*/(0, _react.createContext)(defaultState);
const IndicatorProvider = ({
  children
}) => {
  var _buildInfo$latestBuil2;
  const {
    FEEDBACK_COOKIE_NAME,
    DAYS_BEFORE_FEEDBACK,
    INTERACTION_COOKIE_NAME,
    INTERACTIONS_BEFORE_FEEDBACK
  } = _constants.configs;
  const rootDomain = window.location.hostname.split(`.`).reverse().splice(0, 2).reverse().join(`.`);
  const isOnPrettyUrl = () => /^preview-/.test(window.location.hostname);
  const [cookies, setCookies] = (0, _react.useState)(defaultState.cookies);
  const [askForFeedback, setAskForFeedback] = (0, _react.useState)(false);
  const [currentBuildStatus, setCurrentBuildStatusData] = (0, _react.useState)(null);
  const [buildInfo, setBuildData] = (0, _react.useState)(null);
  const [contentSyncInfo, setContentSyncData] = (0, _react.useState)(null);
  const [manifestInfo, setManifestData] = (0, _react.useState)(null);
  const interactionCount = (0, _react.useMemo)(() => cookies[INTERACTION_COOKIE_NAME] ? parseInt(cookies[INTERACTION_COOKIE_NAME]) : 0, [cookies[INTERACTION_COOKIE_NAME]]);
  const showFeedback = (0, _react.useMemo)(() => askForFeedback && interactionCount > INTERACTIONS_BEFORE_FEEDBACK, [askForFeedback, interactionCount]);
  const currentBuildId = (0, _react.useMemo)(() => {
    const host = window.location.hostname;
    if (isOnPrettyUrl() || host === `localhost`) {
      var _buildInfo$latestBuil;
      return buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$latestBuil = buildInfo.latestBuild) === null || _buildInfo$latestBuil === void 0 ? void 0 : _buildInfo$latestBuil.id;
    } else {
      // Match UUID from preview build URL https://build-af44185e-b8e5-11eb-8529-0242ac130003.gtsb.io
      const buildIdMatch = host.match(/build-(.*?(?=\.))/);
      if (buildIdMatch) {
        return buildIdMatch[1];
      }
      return null;
    }
  }, [buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$latestBuil2 = buildInfo.latestBuild) === null || _buildInfo$latestBuil2 === void 0 ? void 0 : _buildInfo$latestBuil2.id]);
  const usingContentSync = (0, _react.useMemo)(() => !!contentSyncInfo, [contentSyncInfo]);

  // cookie methods
  const setCookie = (name, value) => {
    _jsCookie.default.set(name, value, {
      domain: rootDomain
    });
    const newValue = {
      [`${name}`]: value
    };
    setCookies(newValue);
  };
  const getCookie = name => _jsCookie.default.get(name);
  const removeCookie = name => {
    _jsCookie.default.remove(name, {
      domain: rootDomain
    });
    if (name in cookies) {
      delete cookies[name];
      setCookies(cookies);
    }
  };

  // buildInfo methods
  const setBuildInfo = info => {
    setBuildData(info);
  };
  const setCurrentBuildStatus = status => {
    setCurrentBuildStatusData(status);
  };

  // contentSyncInfo methods
  const setContentSyncInfo = info => {
    setContentSyncData(info);
  };

  // manifestInfo methods
  const setManifestInfo = info => {
    setManifestData(info);
  };

  // feedback methods
  const checkForFeedback = () => {
    const lastFeedback = getCookie(FEEDBACK_COOKIE_NAME);
    if (lastFeedback) {
      const lastFeedbackDate = new Date(lastFeedback);
      const now = new Date();
      const diffInDays = (0, _dateFns.differenceInDays)(now, lastFeedbackDate);
      const askForFeedback = diffInDays >= DAYS_BEFORE_FEEDBACK;
      setAskForFeedback(askForFeedback);
    } else {
      setAskForFeedback(true);
    }
  };

  // track event methods
  const trackEvent = async ({
    eventType,
    name
  }) => {
    checkForFeedback();
    if (askForFeedback) {
      const interactions = isNaN(parseInt(getCookie(INTERACTION_COOKIE_NAME))) ? 0 : parseInt(getCookie(INTERACTION_COOKIE_NAME));
      setCookie(INTERACTION_COOKIE_NAME, `${interactions + 1}`);
    }
    if (process.env.GATSBY_TELEMETRY_API) {
      try {
        var _buildInfo$siteInfo, _buildInfo$siteInfo2;
        const body = {
          time: new Date(),
          eventType,
          componentId: `gatsby-plugin-gatsby-cloud_preview-indicator`,
          version: 1,
          componentVersion: process.env.GATSBY_PREVIEW_UI_APP_VERSION || `4.11.0-next.0`,
          organizationId: buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$siteInfo = buildInfo.siteInfo) === null || _buildInfo$siteInfo === void 0 ? void 0 : _buildInfo$siteInfo.orgId,
          siteId: buildInfo === null || buildInfo === void 0 ? void 0 : (_buildInfo$siteInfo2 = buildInfo.siteInfo) === null || _buildInfo$siteInfo2 === void 0 ? void 0 : _buildInfo$siteInfo2.siteId,
          buildId: currentBuildId,
          name
        };
        await fetch(process.env.GATSBY_TELEMETRY_API, {
          mode: `cors`,
          method: `POST`,
          headers: {
            "Content-Type": `application/json`
          },
          body: JSON.stringify(body)
        });
      } catch (e) {
        console.log(e, e.message);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(IndicatorContext.Provider, {
    value: {
      currentBuildId,
      cookies,
      askForFeedback,
      showFeedback,
      buildInfo,
      contentSyncInfo,
      manifestInfo,
      currentBuildStatus,
      usingContentSync,
      isOnPrettyUrl,
      checkForFeedback,
      trackEvent,
      setCookie,
      getCookie,
      removeCookie,
      setCurrentBuildStatus,
      setBuildInfo,
      setContentSyncInfo,
      setManifestInfo
    }
  }, children);
};
exports.IndicatorProvider = IndicatorProvider;
var _default = IndicatorContext;
exports.default = _default;